/**
 * Global roles (bitwise values for efficient permission storage)
 * These roles are system-wide and stored in the top-level global claims (c)
 */
export enum GlobalRoles {
  Admin = 1 << 0,              // 1
  SuperAdmin = 1 << 1,         // 2
}
